import { connect } from 'react-redux'
import { actions, selectors } from '@bt-react/store'
import Attachments from './Attachments'

const mapStateToProps = (state: any, props: any) => {

    const resource = typeof state.resources !== 'undefined' ? state.resources[`${props.webcastId}`] : null
    const webcastData = selectors.selectWebcast(state, `${props.channelId}${props.webcastId}`)
    return {
        resourceData: (resource && resource.data && resource.data.resources) ? resource.data.resources : [],
        view: state.resources && state.resources.view,
        status: state.resources && state.resources.status,
        webcastData
    }
}

const mapDispatchToProps = (dispatch: any) => ({
    fetchResourceData: (channelId: string, webcastId: string) =>
        dispatch(actions.resource.fetchResourceData(channelId, webcastId))
})

export default connect(mapStateToProps, mapDispatchToProps)(Attachments)
